import React, { useCallback, useState } from 'react';
import { useModalControls } from 'state/modals';
import { useIsEmailVerified } from 'state/user';
import * as S from './styles';
import useOwnershipResult from './useOwnershipResult';

type ClaimPodcastButtonProps = {
  children?: React.ReactNode;
  onPress?: () => void;
};

const ClaimPodcastButton: React.FC<ClaimPodcastButtonProps> = ({
  children = 'claim your podcast',
  onPress,
}) => {
  const { data: isVerified } = useIsEmailVerified();
  const { open, close } = useModalControls();

  const [podcastId, setPodcastId] = useState<string | undefined>();

  const openPodcastSearch = useCallback(() => {
    open({
      name: 'PodcastSearch',
      params: {
        disableEpisodeSearch: true,
        onPodcastSelected: (value) => {
          setPodcastId(value.podcastId);
          close();
        },
      },
    });
  }, [close, open]);

  // if a podcast has been selected,handle it
  const { isLoading } = useOwnershipResult({
    podcastId,
  });

  const handlePress = useCallback(() => {
    onPress?.();
    if (isVerified) {
      openPodcastSearch();
    } else {
      open({
        name: 'VerifyEmail',
        params: {
          onVerify: openPodcastSearch,
        },
      });
    }
  }, [isVerified, onPress, open, openPodcastSearch]);

  return (
    <>
      {isLoading && <S.Loader />}
      <S.Button onPress={handlePress}>{children}</S.Button>
    </>
  );
};

export default ClaimPodcastButton;
